<template>
  <div class="wrapper">
    <b-form-fieldset :label="label">
      <b-input-group>
         <autocomplete 
                :source="uri"
                :placeholder="place"
                :input-class-required="classeRequired"
                results-display="CODIGONOME"
                results-value="ID"
                @input="setId"
                @clear="clearComplete({})"
                ref="auto">
          </autocomplete>

          <b-input-group-button slot-scope="right" class="botao">>
            <!-- Attach Right button -->
            <b-button variant="outline-secondary" class="botao"  v-b-modal.modalPreventTabelaPreco>{{labelBotao}}
              <i class="fa fa-ellipsis-h"></i>
            </b-button>
        </b-input-group-button>
      </b-input-group>
    </b-form-fieldset>
    <b-modal id="modalPreventTabelaPreco"
             ref="modalTabelaPreco"
             title="Pesquisar Tabela Preco"
             class="modal-primary"
             size="lg"
             ok-title="Cancelar"
             ok-only
             @shown="clearModal">
      <b-card>
      <form @submit.stop.prevent="handleSubmit">
        <!-- <b-form-input type="text" placeholder="Enter your name" v-model="resultado"></b-form-input> -->
        <div class="row">
          <!--/.col-->
          <div class="col-sm-4">
            <b-form-fieldset label="Código">
              <b-form-input type="text" id="codigo" ref="edNomePesquisa" placeholder="Informe o código" v-model="pesquisa.id"></b-form-input>
            </b-form-fieldset>
          </div>
        </div>
        <div class="row">
          <!--/.col-->
          <div class="col-sm-8">
              <b-form-fieldset label="Nome">
                <b-form-input type="text" id="nome" placeholder="Informe o Nome" v-model="pesquisa.nome"> </b-form-input>
              </b-form-fieldset>
          </div>
        </div>
        <div class="row">       
          <div class="col-sm-8">   
            <!-- Button -->
            <b-button  type="submit" variant="primary" @click.stop.prevent="onSubmit()">
              <span>Pesquisar</span>
            </b-button>  
            <!-- Button -->
            <b-button type="reset"  variant="danger">
                  <i class="fa fa-ban"></i> Limpar
            </b-button>
          </div>
        </div>
      </form>
      </b-card>
      <b-row  v-if="this.items.length &&  this.items.length > 0">
        <div class="col-sm-12">
            <!-- Main table element -->
            <b-table striped hover 
                    :busy.sync="isBusy" 
                    :items="items" 
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    @row-clicked="selecionar">
              <template slot="codigo" slot-scope="item">{{item.item.CODIGO}}</template>
              <template slot="nome" slot-scope="item">{{item.item.NOME}}</template>
              <template slot="codigo" slot-scope="item">{{item.item.RAZAOSOCIAL}}</template>
            </b-table>
            <div class="justify-content-center row my-1">
              <b-pagination size="md" :total-rows="this.items.length" :per-page="perPage" v-model="currentPage" />
            </div>
        </div>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import Autocomplete from '../componentes/Autocomplete'

export default {
  props: {
    label: String,
    place: String,
    labelBotao: String,
    idInicial: Number,
    classeRequired: Boolean
  },
  data () {
    return {
      resultado: '',
      pesquisa: {
        id: '',
        nome: ''
      },
      isLoading: false,
      status: '',
      isBusy: false,
      items: [],
      fields: {
        ID: { column: 'Código', label: 'Id', sortable: true, class: 'my-left-border my-left-right my-left-bottom'   },
        NOME: { column: 'Nome', label: 'Nome', sortable: true, class: 'my-left-border my-left-right my-left-bottom',   },
        RAZAOSOCIAL: { column: 'Nome', label: 'Razão Social', sortable: true, class: 'my-left-border my-left-right my-left-bottom',   }
      },
      currentPage: 1,
      perPage: 5,
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      uri: this.$http.defaults.baseURL.concat('api/protected/tabelaprecoautocomplete?&texto=')
    }
  },
  components: {
    VueButtonSpinner,
    Autocomplete
  },
  methods: {
    setId (evt) {
      this.$emit('retornaId', evt)
    },
    clearComplete (obj) {
      this.$emit('retornaId', null)
    },
    clearModal () {
      this.items = []
      this.pesquisa.id = ''
      this.pesquisa.nome = ''
      this.$refs.edNomePesquisa.focus()
    },
    selecionar (evt) {
      this.$emit('retornaId', evt.ID)
      this.$emit('retornaNome', evt.CODIGONOME)
      this.clearModal()
      this.$refs.modalTabelaPreco.hide()
      this.$refs.auto.display = evt.CODIGONOME
    },
    onSubmit () {
      if ((!this.pesquisa.id) && (!this.pesquisa.nome)) {
        alert('Por Favor! Informe algum texto/valor para pesquisar')
        return
      }
      this.isLoading = true
      this.isBusy = true
      let uri = `/api/protected/tabelaprecolocalizar?idPesquisa=${this.pesquisa.id}&nomePesquisa=${this.pesquisa.nome}`
      let promise = this.$http.get(uri)
      return promise.then((data) => {
        this.items = data.data
        this.isBusy = false
        this.isLoading = false
        this.status = true // or success
        setTimeout(() => {
          this.status = ''
        }, 1000) // to clear the status :)
      }).catch((error) => {
        if (error) {
          this.items = []
          this.isLoading = false
          this.status = false // or error
        }
      })
    },
    atualizaComplete () {
      if (this.idInicial) {
        let uri = `/api/protected/tabelaprecopesquisaridmin?idPesquisa=${this.idInicial}`
        let promise = this.$http.get(uri)
        return promise.then((data) => {
          this.$refs.auto.display = data.data[0].CODIGONOME
          this.$refs.auto.selectedDisplay = data.data[0].CODIGONOME
          this.$refs.auto.value = data.data[0].ID
        })
      }
    }
  },
  watch: {
    // escuta o idInicial para pesquisar o vendedor se o cadastro tiver vendedor_id por exemplo
    'idInicial': function () {
      this.atualizaComplete()
    }
  },
  created () {
    this.atualizaComplete()
  }
}
</script>
<style>
.modal-dialog {
  top: 50px
}
.botao{
  border-radius: 0;
  border: 2px solid #20a8d8;
}
.b-table .my-left-border {
  border-left: 1px solid #a4b7c1;
}
.b-table .my-left-right {
  border-right: 1px solid #a4b7c1;
}
.b-table .my-left-bottom {
  border-bottom: 1px solid #a4b7c1;
}
</style>



// WEBPACK FOOTER //
// src/views/pesquisa/TabelaPrecoPesquisa.vue